//
//  Will add additional elements to calculate target's height.
//  Can be attached to multiple items
//
import { Directive, Input, OnInit, OnDestroy, ElementRef } from '@angular/core';


import { HeightAdjustService } from './height-adjust.shared.service';

@Directive({
    selector: '[directive-height-offset]',
})
export class HeightOffsetDirective implements OnInit, OnDestroy {
    private _init: boolean = false;
    private _elem: HTMLElement;

    @Input() public targetId: string;

    constructor(
        private _elementRef: ElementRef,
        private _heightAdjustService: HeightAdjustService,
    ) {

    }

    ngOnInit(): void {
        this._elem = this._elementRef.nativeElement;

        if (!this.targetId) return console.warn('[targetId] in directive [directive-height-offset] is not provided. Element: ', this._elem);

        this._init = true;

        this._heightAdjustService.addOffsetElement(this.targetId, this._elem);
    }

    ngOnDestroy(): void {
        if (!this._init) return;

        this._heightAdjustService.removeOffsetElement(this.targetId, this._elem);
    }
}
